<template>
  <div class="popup-full">
    <div class="popup-full__wrap">
      <BasePreloader v-if="pendingAcceptInvite"/>
      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__media">
            <picture class="popup-full__img">
              <img src="@/assets/img/take-to-work.jpg"
                   :alt="$tMyVacancy('modal_accept_invite_title')">
            </picture>
          </div>

          <h3 class="popup-full__title">{{ $tMyVacancy('modal_accept_invite_title') }}</h3>
          <div class="popup-full__text text">
            <p>{{ $tMyVacancy('modal_accept_invite_text') }}</p>
          </div>

          <BaseAlert :value="error"
                     class="popup-full__error  _warning"/>

          <div class="popup-full__buttons">
            <button type="button"
                    @click.prevent="onAcceptInvite"
                    class="popup-full__btn  base-btn base-btn--green">
              <span>{{ $tMyVacancy('modal_accept_invite_btn') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import handleError from '@/helpers/handleError'

  export default {
    name: 'ModalAcceptInvite',
    props: {
      resumeId: Number
    },
    data() {
      return {
        pendingAcceptInvite: false,
        error: null,
      }
    },
    methods: {
      onAcceptInvite() {
        this.pendingAcceptInvite = true

        http.post('/api/new-interaction/accept-interaction', {
          sent_resume_id: this.resumeId
        }).then(() => {
          this.close()
        }).catch(e => {
          this.error = handleError(e)
        }).finally(() => {
          this.pendingAcceptInvite = false
        })
      },
      close() {
        this.$vModal.close('accept-invite')
      }
    }
  }
</script>

<style lang="less">

</style>
